import React from 'react';
const testimonials = [{
  name: 'Markus W.',
  role: 'C-Jugend Trainer, TSV München',
  text: 'Seit ich Handball-Fix nutze, spare ich jede Woche mindestens 4 Stunden. Meine Spieler merken den Unterschied – die Einheiten sind strukturierter und abwechslungsreicher als je zuvor.',
  stars: 5,
  highlight: '4 Stunden pro Woche gespart'
}, {
  name: 'Sandra K.',
  role: 'Jugendkoordinatorin, SG Flensburg-Handewitt II',
  text: 'Endlich ein System, das wirklich funktioniert. Die Saisonplanung war in 10 Minuten fertig. Mein Verein war beeindruckt von der Professionalität der Unterlagen.',
  stars: 5,
  highlight: 'Saisonplanung in 10 Minuten'
}, {
  name: 'Thomas R.',
  role: 'Aktive Herren, TV Großwallstadt',
  text: 'Als Trainer mit wenig Erfahrung war ich oft unsicher. Mit Handball-Fix habe ich sofort professionelle Einheiten parat. Die Taktikkarten sind Gold wert!',
  stars: 5,
  highlight: 'Sofort professionelle Einheiten'
}, {
  name: 'Julia M.',
  role: 'D-Jugend Trainerin, HC Erlangen',
  text: 'Die Kinder lieben die neuen Übungen! Seitdem ich das Paket nutze, kommen alle mit viel mehr Motivation in die Halle. Absolute Empfehlung!',
  stars: 5,
  highlight: 'Mehr Motivation im Team'
}, {
  name: 'Stefan B.',
  role: 'B-Jugend Trainer, THW Kiel Jugend',
  text: 'Ich habe schon viele Ressourcen ausprobiert, aber nichts kommt an Handball-Fix heran. Die 101 Drills allein sind den Preis zehnmal wert.',
  stars: 5,
  highlight: '101 Drills allein den Preis wert'
}, {
  name: 'Petra H.',
  role: 'Kreisliga Trainerin, HSG Wetzlar',
  text: 'Mein Wochenende gehört wieder mir! Früher habe ich Sonntage mit der Planung verbracht. Jetzt öffne ich das PDF und bin in 5 Minuten fertig.',
  stars: 5,
  highlight: 'Wochenende zurückgewonnen'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-bg-dark py-20 px-4 relative overflow-hidden" data-id="element-220">
      {/* Decorative background */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(37,99,235,0.06) 0%, transparent 70%)'
    }} data-id="element-221"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-222">
        <div className="text-center mb-14" data-id="element-223">
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight" data-id="element-224">
            Was andere Trainer sagen
          </h2>
          <p className="text-text-sec text-lg sm:text-xl font-medium" data-id="element-225">
            Über{' '}
            <span className="text-primary font-bold" data-id="element-226">
              800 verifizierte Bewertungen
            </span>{' '}
            mit einem Durchschnitt von 4.9/5 ⭐
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6" data-id="element-227">
          {testimonials.map((t, i) => <div key={i} className="bg-bg-alt rounded-2xl border border-border-light p-6 sm:p-7 flex flex-col gap-4 hover:-translate-y-1 transition-transform duration-300 relative overflow-hidden group" data-id="element-228">
              {/* Subtle hover glow */}
              <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-229"></div>

              {/* Stars */}
              <div className="flex items-center gap-1 relative z-10" data-id="element-230">
                {Array.from({
              length: t.stars
            }).map((_, s) => <span key={s} className="text-secondary text-base" data-id="element-231">
                    ⭐
                  </span>)}
              </div>

              {/* Highlight badge */}
              <span className="inline-flex self-start bg-cta-green/10 text-cta-green border border-cta-green/20 px-3 py-1 rounded-full text-xs font-bold relative z-10" data-id="element-232">
                ✓ {t.highlight}
              </span>

              {/* Quote */}
              <p className="text-text-main text-base leading-relaxed font-medium relative z-10 flex-1" data-id="element-233">
                "{t.text}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 pt-3 border-t border-border-light/50 relative z-10" data-id="element-234">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-primary/20 to-primary/5 border border-primary/30 flex items-center justify-center shadow-inner flex-shrink-0" data-id="element-235">
                  <span className="text-sm font-bold text-primary" data-id="element-236">
                    {t.name.charAt(0)}
                  </span>
                </div>
                <div data-id="element-237">
                  <p className="text-text-main font-bold text-sm" data-id="element-238">{t.name}</p>
                  <p className="text-text-sec text-xs" data-id="element-239">{t.role}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}